import React from 'react';
import { Icon } from './Icon.js';
export const IconCircleSortArrowsFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9,1C4.589,1,1,4.589,1,9s3.589,8,8,8,8-3.589,8-8S13.411,1,9,1Zm2.151,9.991l-1.695,1.978c-.24,.28-.672,.28-.911,0l-1.695-1.978c-.334-.389-.057-.991,.456-.991h3.39c.513,0,.789,.602,.456,.991Zm-.456-2.991h-3.39c-.513,0-.789-.602-.456-.991l1.695-1.978c.24-.28,.672-.28,.911,0l1.695,1.978c.334,.389,.057,.991-.456,.991Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconCircleSortArrowsFill18.js.map